import React from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn,
  TableRow, TableRowColumn, Toggle } from 'material-ui'

import MemberIcon from './MemberIcon'

class TeamListView extends React.Component {

  render() {
    return (
      <div style={styles.listViewStyles}>
        <Table>
          <TableHeader
            style={styles.tableHeaderStyles}
            displaySelectAll={false}
            adjustForCheckbox={false}>
            <TableRow style={styles.tableHeaderRowStyles}>
              <TableHeaderColumn style={styles.headingTextStyles}>Name</TableHeaderColumn>
              <TableHeaderColumn style={styles.headingTextStyles}>Phone Number</TableHeaderColumn>
              <TableHeaderColumn style={styles.headingTextStyles}>Admin</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
            showRowHover={true}>
            {this.props.list.map(member =>
              <TableRow
                style={styles.memberRowStyles}
                key={member.userId}
                onTouchTap={() => this.props.onMemberSelected(member.userId)}
                displayBorder={false}
                selectable={false}>
                <TableRowColumn>
                  <div style={styles.nameColumnStyles}>
                    <MemberIcon member={member} />
                    <div style={styles.memberNameStyles}>
                      {member.displayName}
                    </div>
                  </div>
                </TableRowColumn>
                <TableRowColumn style={styles.phoneStyles}>
                  {member.userId}
                </TableRowColumn>
                <TableRowColumn>
                  <Toggle toggled={member.access === 'admin'} />
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    )
  }
  
}

const styles = {
  memberRowStyles: {
    border: 'solid 1px rgba(0, 0, 0, 0.12)'
  },
  listViewStyles: {
    flexGrow: 0,
    flexShrink: 0
  },
  memberNameStyles: {
    height: 25,
    flexGrow: 0,
    flexShrink: 0,
    fontSize: 18,
    color: '#757575',
    marginLeft: 18
  },
  nameColumnStyles: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  phoneStyles: {
    fontSize: 14,
    color: '#bdbdbd'
  },
  tableHeaderStyles: {
    backgroundColor: '#fafafa'    
  },
  tableHeaderRowStyles: {
    height: 0
  },
  headingTextStyles: {
    fontSize: 14,
    height: 0,
    paddingTop: 6,
    paddingBottom: 6
  }
}

export default TeamListView


// WEBPACK FOOTER //
// ./src/team/TeamListView.js